import React, {Component} from 'react';
import {Spin} from 'antd';
import allegatiStatic from '@common/utils/static/allegati'
import DocumentiForm from '@common/components/Documenti';

class Documenti extends Component {

  state = {
    loading: false,
    searched_anagrafica: false,
    model_anagrafica: {},
    open_drawer: false,
    selected_funzione: null
  }

  getFormLayout() {

  }

  getDominioDocumentale(){
    return this.props.accreditamento.accreditamentotipologie[0] && this.props.accreditamento.accreditamentotipologie[0].id_tipologia != 3 ? 'rapporto_lavoro' : 'rapporto_lavoro_apl';
  }

  getMediaTypes(){
    return allegatiStatic.filteredRequiredMediaByTAC(this.props.GlobalStore.stubs.tipo_media, this.getDominioDocumentale(), 'capacita_gestionali')

  }


  componentDidMount () {
    this.setState({model_anagrafica: this.props.anagrafica});
    /*AnagraficaServices.view({expand: 'rapportoLavoro,rapportoLavoro.media'}, this.props.anagrafica.id, (res)=>{
      this.setState({model_anagrafica: res.data.data})
    })*/

  }

  getRapportoLavoro() {
    try {
      return this.state.model_anagrafica.rapportoLavoro.find(el => el.id_ente === this.props.accreditamento.id_ente)
    } catch(e) {
      return {}
    }
  }

  getRapportoLavoroMedia() {
    try {
      return this.getRapportoLavoro().media
    } catch(e) {
      return {}
    }
  }

  /**
   * File obbligatori per le anagrafiche
   * @type {Array}
   */
 /* required_files = ['Autorizzazione al trattamento dei dati personali secondo i termini di legge', 'Dichiarazione della veridicità dei dati riportati, in base al D.P.R. 445 del 28/12/2000'];

  getRequiredMedia() {
    return this.required_files;
  }  */
  // ora li prendiamo dinamicamente dal db

  // L'Ente può cancellare, in fase di risposta all'integrazione, una figura professionale/docente
  // Se la domanda è quindi in stato 13 e manca un documento può caricarlo
  canUpload(){
    const requiredTypeIds= this.getMediaTypes().map(t=>t.id);
    let medias = this.getRapportoLavoroMedia();
    const hasAllRequiredTypes = requiredTypeIds.every(typeId => 
   medias.some(media => media.tipo_media === typeId)
);
    let _no_file = (medias.length == 0);
    console.warn('canUpload', _no_file, medias);
    return (!hasAllRequiredTypes) && (this.props.accreditamento.stato == 13);
  }

  render () {

    let dominio_documentale = this.props.accreditamento.accreditamentotipologie[0] && this.props.accreditamento.accreditamentotipologie[0].id_tipologia != 3 ? 'rapporto_lavoro' : 'rapporto_lavoro_apl';

    return <div>
      <p>I File contrassegnati da asterisco sono obbligatori</p>
      {
        this.state.model_anagrafica.id
        ?
          <DocumentiForm
            accreditation_id={this.props.accreditation_id}
            canDelete={!this.props.readOnly && this.props.accreditamento.stato == 1}
            canAddNote={false}
            readOnly={ !this.canUpload() && (this.props.readOnly || this.props.accreditamento.stato != 1)}
            unique={true}
            //media_types={allegatiStatic.filteredAccreditationMedia(this.props.GlobalStore.stubs.tipo_media, this.props.accreditamento.tipo_accreditamento)}
              media_types={allegatiStatic.filteredRequiredMediaByTAC(this.props.GlobalStore.stubs.tipo_media, dominio_documentale, 'capacita_gestionali')}
            medias={this.getRapportoLavoroMedia()}
            current_domain={dominio_documentale}
            current_subdomain="capacita_gestionali"
            required_types={allegatiStatic.filteredRequiredMedia(this.props.GlobalStore.stubs.tipo_media, dominio_documentale, 'capacita_gestionali')}
            ref_id={this.getRapportoLavoro().id}
            onUpload={(medias) => null}
        />
        : <Spin size="large" />
      }
      {allegatiStatic.thereAreMediasFor(this.props.GlobalStore.stubs.tipo_media, dominio_documentale, 'documenti_capacita_gestionali', this.props.accreditamento.tipo_accreditamento) &&
        <div>
          {
            this.state.model_anagrafica.id
              ?
              <DocumentiForm
                accreditation_id={this.props.accreditation_id}
                canDelete={this.props.readOnly ? false : true}
                canAddNote={false}
                readOnly={this.props.readOnly}
                unique={true}
                //media_types={allegatiStatic.filteredAccreditationMedia(this.props.GlobalStore.stubs.tipo_media, this.props.accreditamento.tipo_accreditamento)}
                  media_types={allegatiStatic.filteredRequiredMediaByTAC(this.props.GlobalStore.stubs.tipo_media, dominio_documentale, 'documenti_capacita_gestionali')}
                medias={this.getRapportoLavoroMedia()}
                current_domain={dominio_documentale}
                current_subdomain="documenti_capacita_gestionali"
                required_types={allegatiStatic.filteredRequiredMedia(this.props.GlobalStore.stubs.tipo_media, dominio_documentale, 'documenti_capacita_gestionali')}
                ref_id={this.getRapportoLavoro().id}
                onUpload={(medias) => null}
              /> : <Spin size="large" />
          }</div>}

    </div>
  }

}
export default Documenti;